/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import { observer } from 'mobx-react'
import useRootStore from '@store/useRootStore'
import { message } from 'antd'
import uuid from 'uuid'
import { useOnMount } from '@utils/reactExt'

import { ArrowIco } from '@shared/Icon/ArrowIcon'
// css
import { BackBtn, Button } from '@styles/button.style'
import { isMobile } from 'react-device-detect'
import { Title, TitleWrap } from '@styles/base.style'
import { HomeBannerList, HomeContentsWrap } from '@views/Home/index.style'
import NavBar from '@views/Navbar'
import { Schema$GameBanner } from '@interface/common'
import PopupUtils from '@utils/popup-utils'

let fetchPublishedBannerTimer = null

const AdvNewsDetail: React.FC = () => {
  const { routerStore, componentStore } = useRootStore()
  const { publishedBanners } = componentStore

  useOnMount(() => {
    clearTimeout(fetchPublishedBannerTimer)
    fetchPublishedBannerTimer = setTimeout(() => {
      componentStore.fetchPublishedBanner().catch(err => console.error(err))
    })
  })

  const onClickBanner = (banner: Schema$GameBanner): void => {
    if (banner.contentsImageUrl) {
      componentStore.setSelectedGameBanner(banner)
      PopupUtils.showMatchupBannerPopup()
    } else {
      message.info('추가 내용이 없습니다.')
    }
  }

  let bannerElements = []
  if (publishedBanners) {
    bannerElements = publishedBanners.map((banner, index) =>
      <Button key={uuid.v4()} className="banner-btn" onClick={() => {
        onClickBanner(banner)
      }}>
        <img src={banner.homeImageUrl} alt={banner.desc} loading="lazy"/>
      </Button>,
    )
  }

  return (
    <Fragment>
      <HomeContentsWrap>
        <TitleWrap className={`title-wrap no-bg ${isMobile && 'no-header'}`}>
          {isMobile && (
            <BackBtn onClick={() => routerStore.goBack()}>
              <ArrowIco/>
            </BackBtn>
          )}
          {!isMobile && <Title className="title">승부사 소식</Title>}
        </TitleWrap>

        <HomeBannerList className={isMobile? 'banner-list-page':'banner-list-page pc-home-banner-list'}>
          {bannerElements.map((listImg, index) => (
            <li className="list-item" key={`HomeBanner:List:Item:${String(index)}`}>
              {listImg}
            </li>
          ))}
        </HomeBannerList>
      </HomeContentsWrap>
      {isMobile && <NavBar key="AdvNewsDetail:NavBar"/>}
    </Fragment>

  )
}

export default observer(AdvNewsDetail)
